export const compareEditedValueWithCurrent = (savedValue:string, currentValue:string) => {
//    Django deletes (trims) whitespaces at the end of a Char fields value. So we can not properly compare two string e.g. meta title or meta description.
    return savedValue === currentValue.trim();
};